import { all } from 'redux-saga/effects'
import { combineReducers } from 'redux'

import * as auth from '../../app/pages/auth'
import * as search from '../../app/pages/searchFilter'
import * as customer from '../../app/pages/customer'
import * as portalUser from '../../app/pages/portalUser'
import * as companyUser from '../../app/pages/user'
import * as requestTable from '../../app/pages/requestTable'
import * as customeRequestTable from '../../app/pages/customRequestTable'
import * as licences from '../../app/pages/licences'
import * as executeSql from '../../app/pages/executeSql'
import * as deviceConfig from '../../app/pages/deviceConfig'
import * as mails from '../../app/pages/mails'
import * as xmlTable from '../../app/pages/xmlTable'
import * as sqlUpdate from '../../app/pages/updateSqlTable'
import * as freeMail from '../../app/pages/mailsList'
import * as erp from '../../app/pages/erp'
import * as partner from '../../app/pages/partner'
import * as serverConfig from '../../app/pages/serverConfig'
import * as systemBackup from '../../app/pages/systemBackup'
import * as udpateTableXML from '../../app/pages/updateTableXML'
import * as reports from '../../app/pages/reports'
import * as systemReports from '../../app/pages/systemReports'

export const rootReducer = combineReducers({
  auth: auth.reducer,
  search: search.reducer,
  customer: customer.reducer,
  portalUser: portalUser.reducer,
  companyUser: companyUser.reducer,
  requestTable: requestTable.reducer,
  customeRequestTable: customeRequestTable.reducer,
  licences: licences.reducer,
  executeSql: executeSql.reducer,
  deviceConfig: deviceConfig.reducer,
  mails: mails.reducer,
  xmlTable: xmlTable.reducer,
  sqlUpdate: sqlUpdate.reducer,
  freeMail: freeMail.reducer,
  erp: erp.reducer,
  partner: partner.reducer,
  serverConfig: serverConfig.reducer,
  systemBackup: systemBackup.reducer,
  udpateTableXML: udpateTableXML.reducer,
  reports: reports.reducer,
  systemReports: systemReports.reducer,
})

export type RootState = ReturnType<typeof rootReducer>

export function* rootSaga() {
  yield all([
    auth.saga(),
    customer.saga(),
    search.saga(),
    portalUser.saga(),
    companyUser.saga(),
    requestTable.saga(),
    licences.saga(),
    executeSql.saga(),
    deviceConfig.saga(),
    mails.saga(),
    xmlTable.saga(),
    sqlUpdate.saga(),
    freeMail.saga(),
    erp.saga(),
    partner.saga(),
    serverConfig.saga(),
    systemBackup.saga(),
    udpateTableXML.saga(),
    reports.saga(),
    systemReports.saga(),
  ])
}
